import React from "react";

const SubTitle = ({ title }: { title: string }) => {
	return <h4 className="text-primary" >{title}</h4>;
};

export default SubTitle;
